import { onBeforeUnmount, onMounted } from 'vue';

export default function useDetectOutsideClick(element: any, callback: any) {
  if (!element) return;

  const listener = (event: any) => {
    if (
      event.target !== element.value &&
      !element?.value?.contains(event.target)
    ) {
      callback();
    }
  };

  onMounted(() => {
    window.addEventListener('click', listener);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('click', listener);
  });

  return { listener };
}
